<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label" translate="PATIENT_DEVICE.VIEW_VITALS">View Patient Vitals</h3>
    </div>
  </div>
  <div class="card-body">
    <dl class="row" *ngFor="let item of patientVitals | keyvalue">
      <dt class="col-sm-3 py-2">{{ item.key }}</dt>
      <dd class="col-sm-9 py-2">{{ item.value }}</dd>
    </dl>
  </div>
  <div class="card-footer">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button mat-button mat-dialog-close><span translate="GLOBAL.CLOSE">Close</span></button>
      </div>
    </div>
  </div>
</div>
